<template>
  <div
    class="widget-customer"
    :class="{ 'unset_error': error }"
  >
    <v-container v-if="value.confirm" fluid class="widget-customer-card">
      <v-row>
        <v-col cols="12" class="pa-0">
          <Card :customer="value" :finishCard="true" @reset="resetCustomerOut" />
        </v-col>
      </v-row>
    </v-container>
    <v-container
      v-else
      fluid
      class="widget-customer-select"
    >
      <v-row
        @click="typeChange(0)"
        class="widget-row none spread"
        :class="{ selected: (type === 0) }"
      >
        <v-col cols="1" class="radio-col">
          <v-radio-group v-model="type" column>
            <v-radio
              :value="0"
              :color="(!$vuetify.theme.dark ? 'grey darken-2' : 'white')"
              off-icon="mdi-cancel"
              on-icon="mdi-cancel"
              class="radio-type"
            ></v-radio>
          </v-radio-group>
        </v-col>
        <v-col cols="11" class="form-col">
          <v-expand-transition>
            <None
              v-if="type === 0"
              :title="lang.customers.widget.noneCustomer"
              @confirmCustomer="confirmCustomer"
            />
          </v-expand-transition>
          <h3 v-show="type !== 0" class="type-title">{{ lang.customers.widget.noneCustomer }}</h3>
        </v-col>
      </v-row>
      <v-row
        @click="typeChange(1)"
        class="widget-row new spread"
        :class="{ selected: (type === 1) }"
      >
        <v-col cols="1" class="radio-col">
          <v-radio-group v-model="type" column>
            <v-radio
              :value="1"
              :color="(!$vuetify.theme.dark ? 'grey darken-2' : 'white')"
              off-icon="mdi-magnify-plus-outline"
              on-icon="mdi-magnify-plus"
              light
              class="radio-type"
            ></v-radio>
          </v-radio-group>
        </v-col>
        <v-col cols="11" class="form-col">
          <v-expand-transition>
            <Form
              v-if="type === 1"
              :value="newNsearchCustomer"
              :title="lang.customers.widget.searchNewCustomer"
              :searchLoading="searchLoading"
              :autoSearch="autoSearch"
              @update="newCustomerUpdate"
              @manual-search="manualSearch"
              @switchedSearch="switchedSearch"
              @confirmCustomer="confirmCustomer"
            />
          </v-expand-transition>
          <h3 v-show="type !== 1" class="type-title">{{ lang.customers.widget.searchNewCustomer }}</h3>
        </v-col>
      </v-row>
      <v-expand-transition>
        <v-row
          v-if="Object.keys(customersList).length || customersList.length"
          @click="typeChange(2)"
          class="widget-row list spread"
          :class="{ selected: (type === 2) }"
        >
          <Save
            v-if="slCustomer"
            v-model="slCustomer"
            :id="customer_id"
            :dialog="edit_dialog"
            @closed="onCloseSave"
          />
          <v-col cols="1" class="radio-col">
            <v-radio-group v-model="type" column>
              <v-radio
                :value="2"
                :color="(!$vuetify.theme.dark ? 'grey darken-2' : 'white')"
                off-icon="mdi-account-edit-outline"
                on-icon="mdi-account-edit"
                light
                class="radio-type"
              ></v-radio>
            </v-radio-group>
          </v-col>
          <v-col cols="11">
            <v-subheader>
              {{ lang.customers.widget.selectCustomer }}
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn small icon v-on="on">
                    <v-icon small color="primary">mdi-information</v-icon>
                  </v-btn>
                </template>
                <span>
                  {{ lang.customers.widget.tooltip.matchCustomers(Object.keys(customersList).length) }}
                  </span>
              </v-tooltip>
                <v-tooltip right>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      icon
                      medium
                      @click.stop="closeSelectCustomer()"
                      class="mr-2 close-btn"
                      color="gray darken-2"
                    >
                      <v-icon medium>mdi-close</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ lang.orders.view.close }}</span>
                </v-tooltip>
            </v-subheader>
            <v-row class="spread">
              <v-col cols="11" class="pa-0">
                <List
                  v-model="customer_id"
                  :list="customersList"
                  @update="selectCustomer"
                />
              </v-col>
              <v-col cols="1" class="actions-col">
                <v-tooltip left>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      @click.stop="confirmCustomer(slCustomer)"
                      :disabled="!customer_id"
                      color="green"
                      class="action-btn"
                      small
                      dark
                    >
                      <v-icon>mdi-check</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ lang.customers.widget.confirmCustomer }}</span>
                </v-tooltip>
                <v-tooltip left>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      @click.stop="editCustomer"
                      :disabled="!customer_id"
                      color="amber"
                      class="action-btn mt-1"
                      small
                      dark
                    >
                      <v-icon>mdi-border-color</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ lang.customers.edit.title }}</span>
                </v-tooltip>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-expand-transition>
    </v-container>
  </div>
</template>

<script>
import appdata from '@/mixins/appdata'
import utils from '@/mixins/utils'
import customers from './mixins/index'
import customersWidget from './mixins/widget'

import Save from './Save'

import None from './templates/widget/None'
import Form from './templates/widget/Form'
import List from './templates/widget/SelectList'
import Card from './templates/widget/Card'

export default {
  mixins: [ appdata, utils, customers, customersWidget ],
  components: { Save, None, Form, List, Card },
  props: {
    value: {
      type: Object,
      required: true
    },
    noneRef: {
      type: String,
      default: ''
    },
    error: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      customer_id: 0,
      autoSearch: true,
      newNsearchCustomer: {},
      slCustomer: {},
      type: 1,
      searchLoading: false,
      customersList: {},
      edit_dialog: false
    }
  },
  methods: {
    newCustomerUpdate (customer) {
      this.customer_id = 0
      this.newNsearchCustomer = Object.assign({}, customer)
    },
    typeChange (type) {
      switch (type) {
        case 0:
          this.customer_id = 0
          this.customersList = {}
          break
        case 1:
          this.customer_id = 0
      }
      this.type = type
    },
    switchedSearch (newValue) {
      this.autoSearch = newValue
      if (newValue) {
        this.searchCustomers(this.newNsearchCustomer)
      } else {
        this.closeSelectCustomer()
      }
    },
    manualSearch () {
      this.searchCustomers(this.newNsearchCustomer)
    },
    selectCustomer (customer) {
      this.slCustomer = Object.assign({}, customer)
      this.customer_id = customer.id
      this.type = 2
    },
    editCustomer () {
      this.edit_dialog = true
    },
    onCloseSave () {
      this.edit_dialog = false
    },
    closeSelectCustomer () {
      this.customersList = {}
      this.customer_id = 0
      if (this.type === 2) this.type = 1
      this.autoSearch = false
    },
    resetCustomerOut () {
      const customer = {
        id: -1,
        phone: '',
        name: '',
        identity: '',
        address: {
          cep: '',
          address: '',
          num: '',
          comp: '',
          neighborhood: '',
          state: null,
          city: null
        },
        confirm: false
      }
      this.$emit('input', customer)
    },
    confirmCustomer (customer) {
      let output = { ...customer }
      output.confirm = true
      this.$emit('input', output)
    }
  },
  created () {
    this.newNsearchCustomer = {
      id: 0,
      phone: '',
      name: '',
      address: {
        cep: '',
        address: '',
        num: '',
        state: this.get_options.default_state,
        city: this.get_options.default_city
      }
    }
  }
}
</script>

<!--style scoped src="./styles/index.css"></!--style>
<style- scoped src="./styles/addresses.css"></style--->
<style src="./styles/widget.scss" lang="scss"></style>
